import * as React from "react";
import ShoppingCart from "@mui/icons-material/ShoppingCart";
import DefaultText from "../../../../components/Text/DefaultText";

interface ContactAndCtaSectionProps {
  isPlants: boolean;
  isIphone: boolean;
  chatImg: string;
  onAddToCart: () => void;
  onViewCart: () => void;
  onMobileAddToCart: () => void;
}

const ContactAndCtaSection = ({
  isPlants,
  isIphone,
  chatImg,
  onAddToCart,
  onViewCart,
  onMobileAddToCart,
}: ContactAndCtaSectionProps) => {
  return (
    <>
      <div className=" total-contact">
        {isPlants ? (
          <div className=" contact-detail">
            <span>714-673-5386 - Call/Text</span>
            <span>tbttropicalfarm@gmail.com</span>
          </div>
        ) : (
          <div className="  contact-detail">
            <span>
              407-714-4961
              <br />
              714-425-9975
            </span>
            <span>tbtpotmanufacturing@gmail.com</span>
          </div>
        )}

        {isIphone ? (
          <div>
            {/* <img src={chatImg} alt="chat" /> */}
          </div>
        ) : (
          <div
            className="btn-add-to-card"
            style={{ cursor: "pointer" }}
            onClick={onAddToCart}>
            <div>
              <ShoppingCart />
            </div>
            <DefaultText>ADD TO CART</DefaultText>
          </div>
        )}
      </div>

      {isIphone && (
        <div className="btn-service">
          <div
            className="btn-add-to-card"
            style={{
              display: "flex",
              justifyContent: "center",
              cursor: "pointer",
              fontSize: 14,
            }}
            onClick={onViewCart}>
            VIEW CART
          </div>
          <div
            className="btn-add-to-card"
            style={{
              cursor: "pointer",
              display: "flex",
              justifyContent: "center",
              fontSize: 14,
            }}
            onClick={onMobileAddToCart}>
            ADD TO CART
          </div>
        </div>
      )}
    </>
  );
};

export default ContactAndCtaSection;
